// extracted by mini-css-extract-plugin
module.exports = {"analyticRange":"DataRange__analyticRange___41Y4Z","label":"DataRange__label___1QGo2","custom":"DataRange__custom___3WHYV"};